// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38H4u","importantInfo":"styles_importantInfo__3wWi0"};